import {observable, action, runInAction, computed} from "mobx";
import {IApiClient} from "../common/api.client";
import {QuestionAnswer, QuestionItem, QuestionnaireData} from "../common/webapicall";

export class QuestionnaireStore {
	constructor(private apiClient: IApiClient) {}

	@observable questionnaire: QuestionnaireData = null;
	@observable isQuestionnaireLoading: boolean = true;
	@observable isQuestionnaireSubmitLoading: boolean = false;

	@action
	async getQuestionnaire(questionnaireType: string) {
		const response = await this.apiClient.questionnaireClient.getQuestionnaire(questionnaireType);
		runInAction(() => {
			if (response) {
				this.isQuestionnaireLoading = false;
				this.questionnaire = response;
			}
		});
	}

	@action
	async submitQuestionnaire(questionnaireType: string): Promise<string> {
		this.isQuestionnaireSubmitLoading = true;
		if (this.isEveryQuestionAnswered) {
			let answers = this.questionnaire.questions.map(
				(q) =>
					({
						taxonomyId: q.taxonomyId,
						questionId: q.questionId,
						questionVariantId: q.questionVariantId,
						answer: q.answer,
					} as QuestionAnswer),
			);

			const res = await this.apiClient.questionnaireClient.submitQuestionnaire(questionnaireType, answers);
			this.isQuestionnaireSubmitLoading = false;
			return res.pendingAnswerSheetId;
		}

		this.isQuestionnaireSubmitLoading = false;
		return;
	}

	@action
	handleAnswerChange(qId: string, answer: boolean) {
		let q = this.questionnaire.questions.find((q) => q.questionId === qId);
		if (q) {
			q.answer = answer;
		}
	}
	@action
	randomizeAnswers() {
		this.questionnaire.questions.forEach((question: QuestionItem) => {
			question.answer = Math.random() < 0.5;
		});
	}

	@action
	clearQuestionnaire() {
		this.isQuestionnaireLoading = true;
		this.questionnaire = null;
	}

	@computed get questionsCount() {
		if (this.questionnaire.questions) {
			return this.questionnaire.questions.length;
		}
		return 0;
	}

	@computed get answeredCount() {
		if (this.questionnaire.questions) {
			return this.questionnaire.questions.filter((q) => q.answer !== null).length;
		}
		return 0;
	}

	@computed get isEveryQuestionAnswered() {
		if (this.questionnaire.questions) {
			return this.questionnaire.questions.every((q) => q.answer !== null);
		}
		return false;
	}
}
